'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForkEditIcon = function ForkEditIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M22 6c-2.188 0-4 1.813-4 4 0 1.5.813 2.75 2 3.438v.563c0 2-2 4-4 4-1.625 0-2.938.375-4 .938v-9.5c1.188-.688 2-1.938 2-3.438 0-2.188-1.75-4-4-4-2.188 0-4 1.813-4 4 0 1.5.813 2.75 2 3.438v13.125c-1.188.688-2 1.938-2 3.438 0 2.188 1.813 4 4 4 2.25 0 4-1.813 4-4 0-1.063-.375-2-1.063-2.75.625-.688 1.563-1.25 3.063-1.25 4 0 8-4 8-8v-.563c1.188-.688 2-2 2-3.438 0-2.25-1.75-4-4-4zM10 4c1.125 0 2 .938 2 2 0 1.125-.875 2-2 2-1.063 0-2-.875-2-2 0-1.063.938-2 2-2zm0 24c-1.063 0-2-.875-2-2 0-1.063.938-2 2-2 1.125 0 2 .938 2 2 0 1.125-.875 2-2 2zm12-16c-1.063 0-2-.875-2-2 0-1.063.938-2 2-2 1.125 0 2 .938 2 2 0 1.125-.875 2-2 2z' })
    );
};

exports.default = ForkEditIcon;